__turbopack_context__.v({
  "combobox_close": "Combobox-module-scss-module__oQkwcG__combobox_close",
  "combobox_group": "Combobox-module-scss-module__oQkwcG__combobox_group",
  "combobox_input": "Combobox-module-scss-module__oQkwcG__combobox_input",
  "combobox_search": "Combobox-module-scss-module__oQkwcG__combobox_search",
  "combobox_wrapper": "Combobox-module-scss-module__oQkwcG__combobox_wrapper",
});
